// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Menu.module.scss  */
.Menu-module-Root_3In {
  font-family: var(--display-font-family);
  font-size: 1rem;
  line-height: 1.5; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Menu/Menu.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB,EAAE","sourcesContent":["/*  imported from Menu.module.scss  */\n.Menu-module-Root_3In {\n  font-family: var(--display-font-family);\n  font-size: 1rem;\n  line-height: 1.5; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
